import React, { useState, useEffect } from "react";

const AddOnWidget = (props) => {
    const [ quantity, setQuantity ] = useState(0);

    useEffect(() => {
        if (props.addOns !== undefined) {
            setQuantity(props.addOns);
        }
    }, []);

    useEffect(() => {
        if (props.onQuantityChange !== undefined && props.onQuantityChange !== null) {
            props.onQuantityChange.apply(this, [props.plan, quantity]);
        }
    }, [quantity]);

    useEffect(() => {
        if (props.reset && (quantity !== props.addOns)) {
            setQuantity(props.addOns);
        }
    }, [props.reset]);

    let label = quantity;

    if (props.labelMaker !== undefined) {
        label = props.labelMaker.apply(this, [props.plan, quantity]);
    }

    return (
        <div className="add-on-widget">
            <div className="decrease" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                if (quantity > 0) {
                    setQuantity(quantity - 1);
                }
            }}>
                <i className="icon ion-minus"/>
            </div>
            <div className="quantity-display">
                {label}
            </div>
            <div className="increase" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                setQuantity(quantity + 1);
            }}>
                <i className="icon ion-plus"/>
            </div>
        </div>
    );
};

export default AddOnWidget;
